module.exports = __webpack_public_path__ + "img/user-logged-out.b2a51cb4.webp";